import React from "react";
import {
  Box,
  LinearProgress,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Zoom
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const UploadProgressBar = ({ progress, isVisible, batchId }) => {
  const isComplete = progress === 100;

  return (
    <Dialog
      open={isVisible}
      TransitionComponent={Zoom}
      keepMounted
      PaperProps={{
        sx: {
          borderRadius: 4,
          padding: 2,
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        },
      }}
    >
      <DialogContent>
        <Stack alignItems="center" spacing={2} sx={{ py: 1 }}>
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: isComplete ? "#e8f5e9" : "#f0f7ff",
              color: isComplete ? "#2e7d32" : "#007fff",
              mb: 1,
            }}
          >
            {isComplete ? (
              <CheckCircleIcon sx={{ fontSize: 35 }} />
            ) : (
              <CloudUploadIcon sx={{ fontSize: 35 }} />
            )}
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, color: "#1e293b" }}>
            {isComplete ? "Upload Successful" : "Uploading Inventory"}
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "#64748b", textAlign: "center", px: 2 }}
          >
            {isComplete
              ? "Your data has been processed and saved."
              : `Processing batch data. Please wait while we sync your records.`}
          </Typography>

          <Box sx={{ width: "100%", mt: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography variant="caption" sx={{ fontWeight: 700, color: "#475569" }}>
                Progress
              </Typography>
              <Typography variant="caption" sx={{ fontWeight: 700, color: "#007fff" }}>
                {progress}%
              </Typography>
            </Box>
            
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: 10,
                borderRadius: 5,
                bgcolor: "#f1f5f9",
                "& .MuiLinearProgress-bar": {
                  borderRadius: 5,
                  background: isComplete 
                    ? "#2e7d32" 
                    : "linear-gradient(90deg, #007fff 0%, #00c6ff 100%)",
                },
              }}
            />
          </Box>

          {batchId && (
            <Box
              sx={{
                mt: 2,
                p: 1,
                width: "100%",
                bgcolor: "#f8fafc",
                borderRadius: 2,
                border: "1px dashed #cbd5e1",
              }}
            >
              <Typography
                variant="caption"
                display="block"
                align="center"
                sx={{ color: "#94a3b8", fontFamily: "monospace" }}
              >
                Batch Reference: {batchId}
              </Typography>
            </Box>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default UploadProgressBar;